'use es6';

import createAction from 'flux-actions/createAction';
import { createTranslatedDangerNotification } from '../utils/alertUtils';
import { getUsageTrackerMeta } from '../utils/usageTracker';
import { RECEIVED_MAB, REQUESTED_MAB, REQUESTED_MAB_FAILED, REQUESTED_MAB_END_EXPERIMENT, REQUESTED_MAB_END_EXPERIMENT_FAILED, REQUESTED_MAB_END_EXPERIMENT_SUCCEEDED, REQUESTED_MAB_PAST_EXPERIMENTS, REQUESTED_MAB_PAST_EXPERIMENTS_FAILED, REQUESTED_MAB_PAST_EXPERIMENTS_SUCCEEDED } from './ActionTypes';
export const requestMAB = createAction(REQUESTED_MAB);
export const receiveMAB = createAction(RECEIVED_MAB, mab => ({
  mab
}));
export const requestedMABFailed = createAction(REQUESTED_MAB_FAILED, error => ({
  error
}));
export const requestMABEndExperiment = createAction(REQUESTED_MAB_END_EXPERIMENT, ({
  mabExperimentId,
  contentType,
  winnerId
}) => ({
  contentType,
  mabExperimentId,
  winnerId
}), ({
  contentType
}) => Object.assign({}, getUsageTrackerMeta('mabInteraction', {
  action: 'clicked-end-test-button',
  'page-type': contentType,
  status: 'success'
})));
export const requestMABEndExperimentFailed = createAction(REQUESTED_MAB_END_EXPERIMENT_FAILED, error => ({
  error
}), (error, contentType) => Object.assign({}, createTranslatedDangerNotification(contentType, 'mabEndTest'), {}, getUsageTrackerMeta('mabInteraction', {
  action: 'end-test',
  'page-type': contentType,
  status: 'fail'
})));
export const requestMABEndExperimentSucceeded = createAction(REQUESTED_MAB_END_EXPERIMENT_SUCCEEDED, ({
  mabEndTest
}) => ({
  mabEndTest
}), ({
  contentType
}) => Object.assign({}, getUsageTrackerMeta('mabInteraction', {
  action: 'end-test',
  'page-type': contentType,
  status: 'success'
})));
export const requestMABPastExperiments = createAction(REQUESTED_MAB_PAST_EXPERIMENTS, (contentId, contentType) => ({
  contentId,
  contentType
}));
export const requestMABPastExperimentsFailed = createAction(REQUESTED_MAB_PAST_EXPERIMENTS_FAILED, error => ({
  error
}));
export const requestMABPastExperimentsSucceeded = createAction(REQUESTED_MAB_PAST_EXPERIMENTS_SUCCEEDED, mabPastExperiments => ({
  mabPastExperiments
}));